import { render, staticRenderFns } from "./LiveScore.vue?vue&type=template&id=db9e95f0&scoped=true&"
import script from "./LiveScore.vue?vue&type=script&lang=js&"
export * from "./LiveScore.vue?vue&type=script&lang=js&"
import style0 from "./LiveScore.vue?vue&type=style&index=0&id=db9e95f0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9e95f0",
  null
  
)

export default component.exports